import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const API_V3_PREFIX = '/api/v3';

@Injectable()
export class ApiV3BaseUrlInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(API_V3_PREFIX)) {
      return next.handle(request);
    }

    const baseUrl = environment.apiUrl.replace(/\/$/, '');
    return next.handle(request.clone({ url: `${baseUrl}${request.url}` }));
  }
}
